import { ANCHOR_TYPE } from 'features/schedulingEngine/constants'
import { TRIGGER_KIND } from './projectedOccurrence'

const mapApiAnchorType = type => {
  if (!type) return null
  if (type === 'participant_start' || type === 'participant_start_date') {
    return ANCHOR_TYPE.participantStartDate
  }
  if (type === 'participant_first_login' || type === 'participant_login') {
    return ANCHOR_TYPE.participantLogin
  }
  if (type === 'absolute' || type === 'exact_date' || type === 'fixed_calendar_date') {
    return ANCHOR_TYPE.fixedCalendarDate
  }
  return type
}

export const inferEngineTriggerKind = schedule => {
  const anchors = schedule?.deploy?.anchors
  if (!Array.isArray(anchors) || !anchors.length) return TRIGGER_KIND.other

  const primaryType = mapApiAnchorType(anchors[0]?.type)
  if (primaryType === ANCHOR_TYPE.visit || primaryType === 'visit') return TRIGGER_KIND.visit
  if (primaryType === ANCHOR_TYPE.instrument || primaryType === 'instrument') return TRIGGER_KIND.instrument
  if (primaryType === ANCHOR_TYPE.fixedCalendarDate) return TRIGGER_KIND.calendar
  if (
    primaryType === ANCHOR_TYPE.participantStartDate ||
    primaryType === ANCHOR_TYPE.participantLogin ||
    primaryType === ANCHOR_TYPE.icfSignatureDate
  ) {
    return TRIGGER_KIND.participant
  }

  const repeatMode = schedule?.repeat?.mode
  if (repeatMode === 'persistent' || schedule?.recurring?.scheme === 'persistent') {
    return TRIGGER_KIND.persistent
  }

  return TRIGGER_KIND.other
}

export const TRIGGER_KIND_DISPLAY_LABELS = {
  [TRIGGER_KIND.visit]: 'Triggered by visit',
  [TRIGGER_KIND.instrument]: 'Triggered by instrument',
  [TRIGGER_KIND.calendar]: 'Deploy by specific date',
  [TRIGGER_KIND.participant]: 'Relative to participant',
  [TRIGGER_KIND.persistent]: 'Persistent',
  [TRIGGER_KIND.other]: 'Other',
}

export const formatTriggerKindLabel = kind =>
  TRIGGER_KIND_DISPLAY_LABELS[kind] || kind || TRIGGER_KIND_DISPLAY_LABELS[TRIGGER_KIND.other]
